<template>
    <div class="product-info noShorex">
        <div class="product-title">岸上观光服务</div>
        <div class="product-shorex-tips">
            <div class="shorex-tips-left"></div>
            <p>您可以在支付完成后界面选择岸上观光服务，或在船票预订完成后前往皇家行前订网站小程序选订。<br>
              您也可以不选订任何行程则视为自助游，您需自行安排目的地游览行程。</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "GuestInfoShorex",
    computed: {
        order () {
            return this.$store.state.booking.order
        },
        shorex () {
            if (!this.order || !this.order.shorex) {
                return {}
            }
            return this.order.shorex
        },
        payShorexCount () {
            if (!this.order) return 0
            return this.order.payShorexCount || 0
        }
    }
}
</script>

<style lang="less" scoped>
.product-info {
    //width: 841px;
    background: #fff;
    vertical-align: 2px;
    margin-bottom: 10px;
    padding: 22px 22px 30px;
    color: #747d80;
    .product-title {
        font-size: 22px;
        letter-spacing: 1px;
        color: #282b2c;

    }
    .product-shorexes {
        border-bottom: solid 1px #DEE3E5;
        .product-shorex-title {
            font-size: 16px;
            font-weight: 600;
            color: #282b2c;
            border-left: solid 3px #54A3DE;
            height: 16px;
            line-height: 16px;
            padding-left: 5px;
            margin: 20px 0;
        }
        .product-shorex-description {
            padding-bottom: 20px;
            font-size: 14px !important;
            font-weight: 600 !important;
            color: #282b2c;
            margin-bottom: 0px;
        }
    }
    .product-shorex-tips {
        padding-top: 22px;
        color: #747d80;
        display: flex;
        align-items: center;
        position: relative;
        padding-left: 10px;
        p {
            margin-bottom: 0px;
        }
         .shorex-tips-left{
           width: 3px;
           height: 15px;
           position: absolute;
           top: 3px;
           left: 0;
         }
        .shorex-tips-left:after{
           content: "";
           width: 3px;
           height: 15px;
           display: block;
           background: #54a3de;
        }
    }
    .parah-num {
        display: inline-block;
        width: 20px;
    }

}
.noShorex {
    padding-bottom: 10px !important;
    .product-shorex-tips {
        padding-top: 0px;
    }
}
</style>

<style lang="less">
.product-info .product-shorexes .product-shorex-description {
    p, span {
        font-size: 14px !important;
    }
}
</style>
